module.exports = __webpack_public_path__ + "img/11.d09b18d8.png";